
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create root element with error boundary
const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

// Render the application with StrictMode
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
